/** Reusable legal strip — copyright, IP statement and legal page links.
 * Rendered at the bottom of every public footer (dark and light variants). */
import { Link } from "react-router-dom";

export const LegalFooter = ({ dark = false, className = "" }) => {
  const base = dark ? "text-[#F0E6D2]/40" : "text-[#8B7A62]";
  const subtle = dark ? "text-[#F0E6D2]/30" : "text-[#8B7A62]/75";
  const link = dark
    ? "text-[#F0E6D2]/50 hover:text-[#E7B54D] transition-colors"
    : "text-[#6B5944] hover:text-[#C28A2E] transition-colors";
  const divider = dark ? "text-[#F0E6D2]/25" : "text-[#8B7A62]/40";

  return (
    <div className={`text-center ${className}`} data-testid="legal-footer">
      <p className={`text-[11px] ${base}`} data-testid="legal-copyright">
        © 2026 The CCS Approach Consultancy Services. All Rights Reserved.
      </p>
      <p className={`mt-2 mx-auto max-w-2xl text-[10px] leading-relaxed ${subtle}`} data-testid="legal-ip-line">
        The CCS Approach™, the CCS Framework, Communicate • Collaborate • Serve, and all original articles,
        Spotlight stories, training materials, graphics, and website content are the intellectual property of
        The CCS Approach Consultancy Services unless otherwise stated.
      </p>
      <nav className="mt-3 flex items-center justify-center gap-x-2 gap-y-1 flex-wrap text-[11px]">
        <Link to="/privacy-policy" className={link} data-testid="footer-privacy-link">Privacy Policy</Link>
        <span className={divider}>·</span>
        <Link to="/terms-of-use" className={link} data-testid="footer-terms-link">Terms of Use</Link>
        <span className={divider}>·</span>
        <Link to="/intellectual-property" className={link} data-testid="footer-ip-link">Intellectual Property Notice</Link>
      </nav>
    </div>
  );
};

export default LegalFooter;
